type Scope = string;
type Operation = string;

export function createType(prefix: Scope, name: Operation): ActionKind {
  return `${prefix}/${name}`;
}

export function createAction(type: ActionKind, payload?: any): Action {
  return {type, payload};
}
